<template>
  <div class="checkbox styled">
    <input
      :id="getId()"
      :checked="checked"
      class="form-control"
      type="checkbox"
      :disabled="disabled"
      @change="onInput(invertValue(value))"
    />
    <field-label :field="field" :is-manager="isManager" :for="getId()" />
  </div>
</template>

<script>
import Field from './Field.vue';
import FieldAccessIcon from './FieldAccessIcon.vue';
import FieldLabel from './FieldLabel.vue';

export default {
  inject: ['lang'],
  components: {
    FieldAccessIcon,
    FieldLabel
  },
  extends: Field,
  computed: {
    checked() {
      return !this.isNegative(this.value);
    }
  },
  methods: {
    isNegative(value) {
      // eslint-disable-next-line eqeqeq
      return value == 0 || value == null || value === false || value === '';
    },
    invertValue(value) {
      return this.isNegative(value) ? 1 : 0;
    }
  }
};
</script>

<style scoped>
.checkbox {
  margin-right: 30px;
}
</style>
